import {ActionCompletionDialogComponent} from '../common/action-completion-dialog/action-completion-dialog.component';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
import {ConfirmActionDialogComponent} from '../common/confirm-action-dialog/confirm-action-dialog.component';
import {CreateInventoryDialogComponent} from '../users/user-details/create-inventory-dialog/create-inventory-dialog.component';
import {DetailsDialogComponent} from '../common/details-dialog/details-dialog.component';
import {EditUserDialogComponent} from '../users/user-details/edit-user-dialog/edit-user-dialog.component';
import {ErrorDialogComponent} from '../common/error-dialog/error-dialog.component';
import {FilterTableDialogComponent} from '../table/filter-table-dialog/filter-table-dialog.component';
import {InventoryRefrigeratorsDialogComponent} from '../inventory-details/inventory-refrigerators-dialog/inventory-refrigerators-dialog.component';
import {LogoutDialogComponent} from '../logout-dialog/logout-dialog.component';
import {
  MAT_DATE_LOCALE, MAT_DIALOG_DEFAULT_OPTIONS,
  MatAutocompleteModule,
  MatBadgeModule,
  MatBottomSheetModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule,
} from '@angular/material';
import {NgModule} from '@angular/core';

@NgModule({
  entryComponents: [
    ActionCompletionDialogComponent,
    ConfirmActionDialogComponent,
    CreateInventoryDialogComponent,
    DetailsDialogComponent,
    EditUserDialogComponent,
    ErrorDialogComponent,
    FilterTableDialogComponent,
    InventoryRefrigeratorsDialogComponent,
    LogoutDialogComponent
  ],
  exports: [
    CdkTableModule,
    CdkTreeModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule
  ],
  providers: [
    {
      provide: MAT_DATE_LOCALE, useValue: 'el-GR'
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        autoFocus: false,
        closeOnNavigation: true,
        disableClose: false,
        hasBackdrop: true,
        width: '1200px'
      }
    }
  ]
})

export class MaterialModule {
}
